// Static content for MIREVSA website

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_6d1f7e30-0be6-4231-8377-fb0dafd802c9/artifacts/ykuylb8x_Mirevsa.png";

// Uploaded ministry images (prioritized over stock)
export const IMAGES = {
  // Real MIREVSA ministry images
  hero:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/mzwis56d_Hero.jpeg",
  evangelisation:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/e929wato_Evangelisation.jpeg",
  formation:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/gr35vuut_Formation.jpeg",
  footerImage:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/0hwl2n5f_Footer%20image.jpeg",

  // Aliases for backward compatibility
  heroOutreach:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/mzwis56d_Hero.jpeg",
  outreachTeam:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/e929wato_Evangelisation.jpeg",
  socialDistribution:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/0hwl2n5f_Footer%20image.jpeg",
  ministryTeam:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/gr35vuut_Formation.jpeg",
  bibleTeaching:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/gr35vuut_Formation.jpeg",
  community:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/0hwl2n5f_Footer%20image.jpeg",
  volunteers:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/0hwl2n5f_Footer%20image.jpeg",
  worshipGroup:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/e929wato_Evangelisation.jpeg",
  prayingHands:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/mzwis56d_Hero.jpeg",
  manPraying:
    "https://customer-assets.emergentagent.com/job_kingdom-harvest-1/artifacts/gr35vuut_Formation.jpeg",
};

// Four vision gallery images for "Une vision, une mission" section (clean gallery — no overlays)
export const VISION_CARDS = [
  {
    alt: "Ministère MIREVSA — Vision 1",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_kingdom-harvest-1/artifacts/pnz0c9n9_Vision1.jpeg",
  },
  {
    alt: "Ministère MIREVSA — Vision 2",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_kingdom-harvest-1/artifacts/yfsgvdct_Vision2.jpeg",
  },
  {
    alt: "Ministère MIREVSA — Vision 3",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_kingdom-harvest-1/artifacts/fwsc0il7_Vision3.jpeg",
  },
  {
    alt: "Ministère MIREVSA — Vision 4",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_kingdom-harvest-1/artifacts/ske0jjq0_Vision4.jpeg",
  },
];

export const DEPARTMENTS = [
  {
    slug: "evangelisation",
    title: "Évangélisation",
    icon: "Megaphone",
    short:
      "Le cœur de notre mission : la diffusion de l'Évangile à travers des actions locales et internationales.",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_kingdom-harvest-1/artifacts/r6yzl3mm_Evangelisation.jpeg",
    subsections: [
      {
        title: "Évangélisation de terrain",
        text: "Actions de rue, quartier par quartier, distribution de brochures et supports audiovisuels.",
      },
      {
        title: "Évangélisation digitale",
        text: "Présence en ligne, contenus chrétiens, campagnes sur les réseaux sociaux et WhatsApp.",
      },
      {
        title: "Missions nationales et internationales",
        text: "Déploiement d'équipes missionnaires en Haïti et à l'étranger.",
      },
      {
        title: "Implantation d'églises",
        text: "Accompagnement à la plantation et au développement de nouvelles églises locales.",
      },
    ],
    cta: "Participer à une mission",
    ctaLink: "/join",
  },
  {
    slug: "priere",
    title: "Prière",
    icon: "HeartHandshake",
    short:
      "La prière est le fondement spirituel de toutes nos actions — intercession et adoration continue.",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_kingdom-harvest-1/artifacts/18mrzi6r_Priere.jpeg",
    subsections: [
      {
        title: "Chaîne d'adoration continue",
        text: "Une chaîne d'adoration et de louange organisée 24h/24 pour soutenir la mission.",
      },
      {
        title: "Cellules de prière",
        text: "Petits groupes de prière de quartier — lieux de proximité spirituelle.",
      },
      {
        title: "Intercession stratégique",
        text: "Corps d'intercesseurs engagés pour Haïti, les leaders et les nations.",
      },
      {
        title: "Événements spirituels",
        text: "Veillées, rencontres de prière et réunions d'intercession en présentiel.",
      },
    ],
    cta: "Rejoindre une cellule de prière",
    ctaLink: "/join",
  },
  {
    slug: "formation",
    title: "Formation",
    icon: "BookOpen",
    short:
      "Former des croyants solides et des leaders efficaces à travers CEFOBIM et nos programmes de spécialisation.",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_kingdom-harvest-1/artifacts/40w6hjp8_Formation.jpeg",
    subsections: [
      {
        title: "Formation des cadres",
        text: "Programmes de leadership pastoral, ministériel et missionnaire.",
      },
      {
        title: "Production de matériels bibliques",
        text: "Création de supports pédagogiques, livres, manuels et vidéos.",
      },
      {
        title: "CEFOBIM — Centre de Formation Biblique",
        text: "École biblique 100% gratuite, accessible via WhatsApp, avec plus de 600 étudiants et une vingtaine de professeurs bénévoles.",
      },
    ],
    cta: "S'inscrire à une formation",
    ctaLink: "/join",
  },
  {
    slug: "social",
    title: "Affaires Sociales",
    icon: "HandHeart",
    short:
      "Exprimer l'amour de Dieu à travers des actions humanitaires et de développement concrètes.",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_kingdom-harvest-1/artifacts/xwikgsxe_Affairre%20sociale.jpeg",
    subsections: [
      {
        title: "Actions médicales et sanitaires",
        text: "Cliniques mobiles, campagnes de santé et de prévention pour les communautés.",
      },
      {
        title: "Développement communautaire",
        text: "Centres communautaires, projets éducatifs et initiatives d'autonomisation.",
      },
      {
        title: "Aide aux personnes vulnérables",
        text: "Distribution de kits alimentaires, soutien aux familles et écoles.",
      },
      {
        title: "Interventions d'urgence",
        text: "Assistance rapide aux personnes en situation de crise ou de détresse.",
      },
    ],
    cta: "Soutenir un projet",
    ctaLink: "/donation",
  },
  {
    slug: "communication",
    title: "Communication & Marketing",
    icon: "Radio",
    short:
      "Direction transversale : visibilité, coordination de l'information et promotion stratégique.",
    image: IMAGES.evangelisation,
    subsections: [
      {
        title: "Communication institutionnelle",
        text: "Coordination des messages, relations médias et présence publique.",
      },
      {
        title: "Marketing & promotion",
        text: "Promotion stratégique des programmes et campagnes de mobilisation.",
      },
      {
        title: "Visibilité digitale",
        text: "Gestion des plateformes en ligne, réseaux sociaux et supports numériques.",
      },
    ],
    cta: "Nous contacter",
    ctaLink: "/contact",
  },
];

export const VALUES = [
  { title: "Foi", text: "Tout ce que nous faisons est ancré dans une foi vivante et active en Dieu." },
  { title: "Intégrité", text: "Nous agissons avec transparence, honnêteté et cohérence dans toutes nos actions." },
  { title: "Engagement", text: "Nous sommes pleinement engagés dans notre mission, quelles que soient les circonstances." },
  { title: "Excellence", text: "Nous cherchons toujours à honorer Dieu par un travail de qualité et d'impact." },
  { title: "Service", text: "Servir les autres est au cœur de tout ce que nous faisons." },
];

export const MISSIONS = {
  local: [
    {
      title: "Évangélisation à Delmas",
      description: "Campagne urbaine de proximité dans la commune de Delmas.",
      image: IMAGES.heroOutreach,
    },
    {
      title: "Mission Cap-Haïtien",
      description: "Croisade et accompagnement des églises locales.",
      image: IMAGES.outreachTeam,
    },
    {
      title: "Outreach Jacmel",
      description: "Évangélisation et distribution alimentaire dans le sud.",
      image: IMAGES.socialDistribution,
    },
  ],
  international: [
    {
      title: "République Dominicaine",
      description: "Partenariat missionnaire avec les églises dominicaines.",
      image: IMAGES.community,
    },
    {
      title: "Floride (USA)",
      description: "Soutien à la diaspora haïtienne et évangélisation.",
      image: IMAGES.worshipGroup,
    },
  ],
  churchPlants: [
    {
      title: "Implantation Léogâne",
      description: "Nouvelle église locale en cours d'établissement.",
      image: IMAGES.bibleTeaching,
    },
    {
      title: "Implantation Carrefour",
      description: "Plantation d'une église communautaire à Carrefour.",
      image: IMAGES.ministryTeam,
    },
  ],
};

export const BIBLE_VERSE =
  "« La moisson est grande, mais il y a peu d'ouvriers. » — Matthieu 9:37";

export const CONTACT = {
  email: "info@mirevsa.org",
  phone: "+509 3631 1809",
  country: "Haïti",
  address: "1, Cassagnol 25, Delmas 75, Port-au-Prince, Haïti",
  whatsapp: "+509 3706-3615",
};

export const NAV_LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/about", label: "À propos" },
  { to: "/departments", label: "Départements" },
  { to: "/events", label: "Événements" },
  { to: "/resources", label: "Ressources" },
  { to: "/contact", label: "Contact" },
];

// Achievements from official history (from https://mirevsa.org/about)
export const ACHIEVEMENTS = [
  "Création du CEFOBIM — école biblique 100% gratuite accessible via WhatsApp, avec plus de 600 étudiants à différents niveaux",
  "Plateforme WhatsApp active atteignant 1 024 membres, et une seconde en pleine croissance",
  "Mobilisation d'une équipe de plus de 80 collaborateurs engagés dans les programmes de l'organisation",
  "Distributions de kits alimentaires en faveur des personnes vulnérables et des écoles",
  "Planification de cliniques mobiles pour répondre aux besoins de santé des communautés",
  "Accompagnement de plusieurs églises dans les domaines de l'évangélisation et du développement ministériel",
  "Développement de projets de centres communautaires et d'initiatives sociales",
];

// Official structure — 4 departments + 1 direction
export const STRUCTURE = [
  { name: "Département de l'Évangélisation", text: "Diffuser l'Évangile sur le terrain, en ligne et à travers des missions locales et internationales." },
  { name: "Département de la Prière", text: "Soutien spirituel par l'intercession et l'adoration continue." },
  { name: "Département de la Formation", text: "Développer les compétences et former des chrétiens à travers le CEFOBIM et des programmes de spécialisation ministérielle." },
  { name: "Département des Affaires Sociales", text: "Actions humanitaires et de développement pour répondre aux besoins des communautés." },
  { name: "Direction de la Communication et du Marketing", text: "Visibilité, coordination de l'information et promotion stratégique." },
];
